export const formatCOP = (n) =>
  new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    maximumFractionDigits: 0,
  }).format(Number(n || 0));

export const formatDate = (iso) => {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleString('es-CO', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return iso;
  }
};

export const statusLabel = {
  pending: 'Pendiente',
  paid: 'Pagado',
  shipped: 'Despachado',
  delivered: 'Entregado',
  cancelled: 'Cancelado',
  active: 'Activo',
  disabled: 'Inactivo',
  approved: 'Aprobado',
  rejected: 'Rechazado',
  incomplete: 'Incompleto',
  suspended: 'Suspendida',
};

export const statusColor = {
  pending: 'bg-amber-100 text-amber-800 border-amber-200',
  paid: 'bg-blue-100 text-blue-800 border-blue-200',
  shipped: 'bg-indigo-100 text-indigo-800 border-indigo-200',
  delivered: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  cancelled: 'bg-rose-100 text-rose-800 border-rose-200',
  active: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  disabled: 'bg-slate-100 text-slate-700 border-slate-200',
  approved: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  rejected: 'bg-rose-100 text-rose-800 border-rose-200',
  incomplete: 'bg-slate-100 text-slate-700 border-slate-200',
  suspended: 'bg-amber-100 text-amber-800 border-amber-200',
};
